module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_notifications-2901807d091564bb332c0b611fd85ca6.png";